import { render, staticRenderFns } from "./OfferProductsList.vue?vue&type=template&id=c9956f20&scoped=true"
import script from "./OfferProductsList.vue?vue&type=script&lang=js"
export * from "./OfferProductsList.vue?vue&type=script&lang=js"
import style0 from "./OfferProductsList.vue?vue&type=style&index=0&id=c9956f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9956f20",
  null
  
)

export default component.exports